import React from 'react';


class NewsletterAd extends React.Component {
	render() {
		return (
		<div className="alert alert-primary newsletter-ad">
		   <strong>Want to keep improving?</strong>
		   <p style={{marginTop:'8px', marginBottom:'8px'}}>
		     Every week, I break down one Mandarin grammar point in a short, clear email. Join thousands of learners reading <em>Chinese Grammar Gems</em>.
		   </p>
		   <div className="hsk-actions">
		     <button className="btn btn-primary" style={{margin:'5px 5px 5px 5px'}} type="button">
		       <a href="https://hsklevel.substack.com" target="_blank" rel="noreferrer noopener"
		          style={{color:'white', textDecoration: 'none', fontSize:'16px'}}>
		           Subscribe for free
		       </a>
		     </button>
		   </div>
		 </div>
		);
	}
}


export default NewsletterAd
